import React, { useState, useEffect } from 'react';

const IdleWarning = ({ isVisible, onContinue, onLogout, remainingTime }) => {
  const [timeLeft, setTimeLeft] = useState(remainingTime);

  useEffect(() => {
    if (isVisible && timeLeft > 0) {
      const timer = setInterval(() => {
        setTimeLeft(prev => {
          if (prev <= 1) {
            onLogout();
            return 0;
          }
          return prev - 1;
        });
      }, 1000);

      return () => clearInterval(timer);
    }
  }, [isVisible, timeLeft, onLogout]);

  useEffect(() => {
    setTimeLeft(remainingTime);
  }, [remainingTime]);

  if (!isVisible) return null;

  const formatTime = (seconds) => {
    const mins = Math.floor(seconds / 60);
    const secs = seconds % 60;
    return `${mins}:${secs.toString().padStart(2, '0')}`;
  };

  return (
    <div style={styles.overlay}>
      <div style={styles.modal}>
        <div style={styles.header}>
          <h3 style={styles.title}>⚠️ Sesión por Expirar</h3>
        </div>
        <div style={styles.body}>
          <p style={styles.message}>
            Su sesión expirará en <strong>{formatTime(timeLeft)}</strong> por inactividad.
          </p>
          <p style={styles.subMessage}>
            ¿Desea continuar con su sesión?
          </p>
        </div>
        <div style={styles.footer}>
          <button 
            onClick={onLogout} 
            style={{...styles.button, ...styles.logoutButton}}
          >
            Cerrar Sesión
          </button>
          <button 
            onClick={onContinue} 
            style={{...styles.button, ...styles.continueButton}}
          >
            Continuar Sesión
          </button>
        </div>
      </div>
    </div>
  );
};

const styles = {
  overlay: {
    position: 'fixed',
    top: 0,
    left: 0,
    right: 0,
    bottom: 0,
    backgroundColor: 'rgba(0, 0, 0, 0.7)',
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    zIndex: 10000,
  },
  modal: {
    backgroundColor: '#fff',
    borderRadius: '12px',
    padding: '0',
    width: '400px',
    maxWidth: '90vw',
    boxShadow: '0 20px 40px rgba(0, 0, 0, 0.3)',
    animation: 'fadeIn 0.3s ease-out',
  },
  header: {
    backgroundColor: '#f8d7da',
    padding: '20px',
    borderRadius: '12px 12px 0 0',
    borderBottom: '1px solid #f5c6cb',
  },
  title: {
    margin: 0,
    color: '#721c24',
    fontSize: '18px',
    fontWeight: 'bold',
  },
  body: {
    padding: '20px',
  },
  message: {
    margin: '0 0 10px 0',
    color: '#333',
    fontSize: '16px',
    lineHeight: '1.5',
  },
  subMessage: {
    margin: '0',
    color: '#666',
    fontSize: '14px',
  },
  footer: {
    padding: '20px',
    display: 'flex',
    gap: '10px',
    justifyContent: 'flex-end',
    borderTop: '1px solid #eee',
  },
  button: {
    padding: '10px 20px',
    border: 'none',
    borderRadius: '6px',
    fontSize: '14px',
    fontWeight: 'bold',
    cursor: 'pointer',
    transition: 'all 0.3s ease',
  },
  logoutButton: {
    backgroundColor: '#dc3545',
    color: '#fff',
  },
  continueButton: {
    backgroundColor: '#28a745',
    color: '#fff',
  },
};

export default IdleWarning;
